import { INeighbourhood } from "@types";
import { BaseAPI } from "@utils";

class NeighbourhoodApi extends BaseAPI<INeighbourhood> {}

export const neighbourhoodApi = new NeighbourhoodApi("/api/v1/neighbourhood");
